import { useState } from "react";
import { EMAIL, PHONE, WA_LINK } from "../../data/siteData";
import { ArrowRight, PageHero } from "../../components/Layout";

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch(
        `https://formsubmit.co/ajax/${EMAIL}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      if (response.ok) {
        setSubmitted(true);
        e.target.reset();
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong.");
    }

    setLoading(false);
  };

  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Tell us what your support desk needs to handle."
        text="Send an enquiry and ClearDesk Support Ltd will respond with the best next step for your call handling, booking, WhatsApp, email, or overflow support."
        backgroundImage="/abouthero.webp"
      />

      <div className="section-pad">
        <div className="contact-page">

          <form
            className="contact-form"
            onSubmit={handleSubmit}
          >
            <input
              type="hidden"
              name="_subject"
              value="New ClearDesk Support website enquiry"
            />

            <input
              type="hidden"
              name="_captcha"
              value="false"
            />

            {submitted ? (
              <div className="form-success full-span">
                <div className="form-success-icon">✓</div>

                <h3>Enquiry Sent Successfully</h3>

                <p>
                  Thank you for reaching out.
                  ClearDesk Support Ltd will contact you shortly.
                </p>
              </div>
            ) : (
              <>
                <label>
                  Full name *
                  <input
                    name="name"
                    type="text"
                    placeholder="Your name"
                    required
                  />
                </label>

                <label>
                  Email address *
                  <input
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    required
                  />
                </label>

                <label>
                  Phone number
                  <input
                    name="phone"
                    type="tel"
                    placeholder="+44..."
                  />
                </label>

                <label>
                  Service needed
                  <select
                    name="service"
                    defaultValue="Call handling"
                  >
                    <option>Call handling</option>
                    <option>Booking support</option>
                    <option>WhatsApp / email support</option>
                    <option>After-hours / overflow support</option>
                    <option>Complete support desk</option>
                  </select>
                </label>

                <label className="full-span">
                  Your message *
                  <textarea
                    name="message"
                    rows={5}
                    placeholder="Tell us about your business, volume, hours, and what you need covered."
                    required
                  />
                </label>

                <button
                  className="btn primary full-span"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send enquiry"}

                  {!loading && <ArrowRight />}
                </button>
              </>
            )}
          </form>

          <aside className="contact-card">
            <p className="eyebrow light">
              Contact details
            </p>

            <h2>Speak to ClearDesk</h2>

            <p>
              Build a support desk around your business
              hours, enquiry volume, and customer expectations.
            </p>

            <a
              href={`tel:${PHONE.replace(/\s/g, "")}`}
              className="contact-link"
            >
              {PHONE}
            </a>

            <a
              href={`mailto:${EMAIL}`}
              className="contact-link"
            >
              {EMAIL}
            </a>

            <a
              href={WA_LINK}
              target="_blank"
              rel="noreferrer"
              className="contact-link wa"
            >
              Message on WhatsApp
            </a>
          </aside>

        </div>
      </div>
    </>
  );
}